module.exports = __webpack_public_path__ + "media/icons/reply-66047a62.svg";